import React, { Component, Fragment } from "react";
import "./WhatsAppQuickMessages.css";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { setModalMessage } from "../../store/actions/general";

import { APPLICATION_NAME } from "../../core/constants";

import Header from "../../components/CRM/Header";
import LimitedDynamicTable from "../../components/general/LimitedDynamicTable";
import Box from "../../components/general/Box";

import WhatsAppQuickMessagesController from "../../controllers/WhatsappQuickMessagesController";
import Button from "../../components/general/Button";
import InputGeneral from "../../components/general/InputGeneral";
import InputArea from "../../components/general/InputArea";
import Select from "../../components/general/Select";
import MessageContent from "../../components/general/MessageContent";
import Check from "../../components/general/Check";
import DropDown from "../../components/general/DropDown";
import ButtonIcon from "../../components/general/ButtonIcon";

const whatsAppQuickMessagesController = new WhatsAppQuickMessagesController();

const initialState = {
    // starts table
    table: <Fragment></Fragment>,
    // end table

    filtered: false,
    showArchives: false,

    titleQuickMessage: "", 
    textQuickMessage: "", 
    optionsDepartaments: [], 
    checkShareDepartaments: false,
    departamentQuickMessage: null, 

    selectIdQuickMessage: null,

    editIdQuickMessage: null, 
    editTextQuickMessage: "",
    editTitleQuickMessage: "",
    editCheckShareDepartaments: false,
    editDepartamentQuickMessage: null,
    
    showModalEditWhatsAppQuickMessages: false,
    showModalCreateWhatsAppQuickMessages: false,

    showCheckShareDepartaments: false,
    showEditCheckShareDepartaments: false,
    
    posY: 300,
    posX: 300,
    widthDropDownMoreActions: 286,
    showDropDownMoreActions: false,
    buttonMore: null,
    header: null,

    disableButtonSaveCreateWhatsAppQuickMessages: false
}

class WhatsAppQuickMessages extends Component
{
    state = {...initialState}
    
    componentDidMount = async () => 
    {
        document.title = `${APPLICATION_NAME} - Mensagens rápidas (whatsapp)`;
        let buttonMore = this.buttonMore;
        let header = this.header;
        
        await this.setState({buttonMore, header});

        let filters = { status: 1 }

        await this.getLimitedDynamicTableForWhatsappQuickMessages(filters);
        await this.getDepartaments();
    }

    componentDidUpdate = async (prevProps, prevState) => 
    {
        if (prevProps.hasPermissionsLoaded !== this.props.hasPermissionsLoaded) 
        {
            if (!this.props.permissions.whatsappQuickMessages.toView) { this.props.history.push(`/activities`); }
        }
    }

    openModalCreateWhatAppQuickMessages = async () =>
    {
        await this.setState({ showModalCreateWhatsAppQuickMessages: true });
    }

    openModalEditWhatAppQuickMessages = async (id) =>
    {
        await this.getInfoQuickMessageById(id);
        await this.setState({showModalEditWhatsAppQuickMessages: true});
    }

    message = (type, message) =>
    {
        this.props.setModalMessage({show: true, type, message});
    }

    getDepartaments = async () =>
    {
        const response = await whatsAppQuickMessagesController.getDepartaments();
        const content = response.data;

        let optionsDepartaments = [];
        let optionsDepartamentsFromFilters = [];

        optionsDepartamentsFromFilters.push(
            {
                name: "Todos os Departamentos".toUpperCase(),
                value: null,
                slug: ""
            }
        );

        for (const departament of content)
        {
            optionsDepartaments.push(
                {
                    name: (departament?.WHD_NAME || "").toUpperCase(),
                    value: departament.WHD_ID,
                    slug: departament.WHD_SLUG
                }
            );

            optionsDepartamentsFromFilters.push(
                {
                    name: (departament?.WHD_NAME || "").toUpperCase(),
                    value: departament.WHD_ID,
                    slug: departament.WHD_SLUG
                }
            );
        }

        await this.setState({optionsDepartaments, optionsDepartamentsFromFilters});
        await this.setState({choosenDepartament: optionsDepartamentsFromFilters.find((departament) => { return departament.value === null })});
    }

    getLimitedDynamicTableForWhatsappQuickMessages = async (filters = {}) =>
    {
        const hasFilters = (Object.keys(filters).length > 0);
        const response = hasFilters ? await whatsAppQuickMessagesController.getByFilters(filters) : await whatsAppQuickMessagesController.get();
        const content = response.data;

        console.log("content: ", content);

        if (content?.length <= 0)
        {
            await this.createTableEmpty();
            return;
        }

        await this.setState({ whatsappQuickMessages: content })

        let header = [
            {
                name: "Titulo",
                justify: "left"
            },
            {
                name: "Texto",
                justify: "left"
            },
            {
                name: "Departamentos",
                justify: "center"
            },
            {
                name: "Compartilhado",
                justify: "center"
            },
            {
                name: "Ações",
                justify: "right"
            }
        ];
        
        let body = [];

        content.forEach((quickMessage, i) => {
            body.push([
                {
                    name: quickMessage.WHQ_TITLE,
                    justify: "left"
                },
                {
                    name: quickMessage.WHQ_MESSAGE,
                    justify: "left"
                },
                {
                    name: quickMessage.formattedDepartamentName,
                    justify: "center"
                },
                {
                    name: quickMessage.WHQ_SHARE === 2 ? "Não Compartilha com outros departamentos" : "Compartilha com outros departamentos",
                    justify: "center"
                },
                {
                    name: (
                        <i
                            className="fa fa-bars iconEditWhatsAppQuickMessages"
                            onClick={async (event) => {
                                const rect = event.currentTarget.getBoundingClientRect();
                                await this.setState({
                                    posX: rect.left - 275,
                                    posY: rect.bottom + 5,
                                    showDropDownMoreActions: true,
                                    selectIdQuickMessage: quickMessage.WHQ_ID
                                });
                            }}d
                        />
                    ),
                    justify: "right"
                }
            ])
        });
        
        let footer = [];

        await this.setState({ table:
            <LimitedDynamicTable
                classaditional="quickMessagesLimitedDynamicTableWhatsAppQuickMessages"
                header={header}
                body={body}
                footer={footer}
                config={{
                    columns: [
                        {
                            index: 0,
                            width: 20
                        },
                        {
                            index: 1,
                            width: 30
                        },
                        {
                            index: 2,
                            width: 20
                        },
                        {
                            index: 3,
                            width: 20
                        },
                        {
                            index: 4,
                            width: 10
                        }
                    ]
                }}
            />
        })
    }

    createTableEmpty = async () =>
    {
        let header = [
            {
                name: " ",
                justify: "center"
            },
            {
                name:  " ",
                justify: "center"
            },
            {
                name:  " ",
                justify: "center"
            }
        ];
        
        let body = [
            [
                {
                    name: "",
                    justify: "center"
                },
                {
                    name: "Não foi encontrado nenhum registro.",
                    justify: "center"
                },
                {
                    name: "",
                    justify: "center"
                }
            ]
        ];
        
        let footer = [];

        await this.setState({ table:
            <LimitedDynamicTable
                classaditional="quickMessagesLimitedDynamicTableWhatsAppQuickMessages"
                header={header}
                body={body}
                footer={footer}
                config={{
                    columns: [
                        {
                            index: 0,
                            width: 25
                        },
                        {
                            index: 1,
                            width: 50
                        },
                        {
                            index: 2,
                            width: 25
                        }
                    ]
                }}
            />
        })
    }

    validation = async (TYPE) =>
    {
        switch (TYPE)
        {
            case "CREATE_WHATSAPP_QUICK_MESSAGE":
                const data = {
                    textQuickMessage: this.state.textQuickMessage,
                    titleQuickMessage: this.state.titleQuickMessage,
                    departamentQuickMessage: this.state.departamentQuickMessage?.value,
                };

                if (data.textQuickMessage === "" || data.titleQuickMessage === "" || !data.departamentQuickMessage)
                {
                    return {
                        message: this.message("error", "Preencha os campos corretamente!"),
                        status: 400
                    };
                }
                else
                {
                    return {
                        status: 200
                    };
                }

            case "EDIT_WHATSAPP_QUICK_MESSAGE":
                const dataEdit = {
                    textQuickMessage: this.state.editTextQuickMessage,
                    titleQuickMessage: this.state.editTitleQuickMessage,
                    departamentQuickMessage: this.state.editDepartamentQuickMessage?.value,
                };

                if (dataEdit.textQuickMessage === "" || dataEdit.titleQuickMessage === "" || !dataEdit.departamentQuickMessage)
                {
                    return {
                        message: this.message("error", "Todos os campos com * deve ser preenchido!"),
                        status: 400
                    };
                }
                else
                {
                    return {
                        status: 200
                    };
                }
        
            default:
                break;
        }
    }

    createWhatsAppQuickMessages = async () =>
    {
        const textQuickMessage = this.state.textQuickMessage;
        const titleQuickMessage = this.state.titleQuickMessage;
        const checkShareDepartaments = this.state.checkShareDepartaments ? 1 : 2;
        const departamentQuickMessage = this.state.departamentQuickMessage?.value;
        const optionsDepartaments = this.state.optionsDepartaments;

        const validation = await this.validation("CREATE_WHATSAPP_QUICK_MESSAGE");

        if (validation.status === 400) { return validation.message; }

        const slugQuickMessage = optionsDepartaments.filter((d) => d.value === departamentQuickMessage)[0].slug;
        const data = {
            "WHQ_ID_DEPARTAMENT": departamentQuickMessage,
            "WHQ_TITLE": titleQuickMessage,
            "WHQ_SHARE": checkShareDepartaments,
            "WHQ_MESSAGE": textQuickMessage,
            "WHQ_STATUS": 1,
            "WHQ_SLUG_DEPARTAMENT": slugQuickMessage
        };
        const response = await whatsAppQuickMessagesController.create(data);

        if (response.status)
        {
            let filters = { status: 1 };
    
            await this.getLimitedDynamicTableForWhatsappQuickMessages(filters);
            await this.message("success", "Mensagem rápida criada com sucesso!");
        }
        else
        {
            await this.message("error", "Houve algum erro ao criar a mensagem. Se o erro persistir, contacte o TI!");
        }

        await this.setState({ 
            showModalCreateWhatsAppQuickMessages: false,
            titleQuickMessage: "", 
            textQuickMessage: "", 
            departamentQuickMessage: null,
            checkShareDepartaments: false,
            showCheckShareDepartaments: false,
        });
    }

    getInfoQuickMessageById = async (id) =>
    {
        const content = this.state.whatsappQuickMessages;
        const quickMessage = content.find((qM) => qM.WHQ_ID === id);

        await this.setState({
            editIdQuickMessage: quickMessage.WHQ_ID, 
            editTitleQuickMessage: quickMessage.WHQ_TITLE,
            editCheckShareDepartaments: quickMessage.WHQ_SHARE === 1 ? true : false,
            editTextQuickMessage: quickMessage.WHQ_MESSAGE,
            editDepartamentQuickMessage: this.state.optionsDepartaments.find((op) => op.value === quickMessage.departament.WHD_ID), 
        });
    }

    editWhatsAppQuickMessages = async () =>
    {
        const idQuickMessage = this.state.editIdQuickMessage;
        const textQuickMessage = this.state.editTextQuickMessage;
        const titleQuickMessage = this.state.editTitleQuickMessage;
        const checkShareDepartaments = this.state.editCheckShareDepartaments ? 1 : 2;
        const departamentQuickMessage = this.state.editDepartamentQuickMessage.value;

        const validation = await this.validation("EDIT_WHATSAPP_QUICK_MESSAGE");

        if (validation.status === 400){ return validation.message; }

        const data = {
            "WHQ_ID_DEPARTAMENT": departamentQuickMessage,
            "WHQ_TITLE": titleQuickMessage,
            "WHQ_SHARE": checkShareDepartaments,
            "WHQ_ID": idQuickMessage,
            "WHQ_MESSAGE": textQuickMessage,
            "WHQ_STATUS": 1
        };

        const response = await whatsAppQuickMessagesController.update(data);
        const status = response.data.status;

        await this.setState({ 
            showModalEditWhatsAppQuickMessages: false,
            editTitleQuickMessage: "",
            editTextQuickMessage: "",
            editDepartamentQuickMessage: null,
        });

        if (status === 200)
        {
            let filters = { status: 1 };
    
            await this.getLimitedDynamicTableForWhatsappQuickMessages(filters);
            return this.message("success", "Mensagem rápida atualizada com sucesso!");
        }
        else
        {
            return this.message("error", "Ocorreu um erro durante a edição da Mensagem Rápida! Reinicie a página e tente novamente.");
        }
    }

    archiveWhatsAppQuickMessages = async (id) =>
    {
        const data = { "WHQ_ID": id, "WHQ_STATUS": 2 };
        const response = await whatsAppQuickMessagesController.update(data);
        const status = response.data.status;

        if (status === 200)
        {
            let filters = { status: 1 };
    
            await this.getLimitedDynamicTableForWhatsappQuickMessages(filters);
            return this.message("success", "Mensagem rápida arquivada com sucesso!");
        }
        else
        {
            return this.message("error", "Houve algum erro ao arquivar a mensagem. Se o erro persistir, contacte o TI!");
        }
    }

    activeWhatsAppQuickMessages = async (id) =>
    {
        const data = {"WHQ_ID": id, "WHQ_STATUS": 1 };
        const response = await whatsAppQuickMessagesController.update(data);
        const status = response.data.status;

        if (status === 200)
        {
            let filters = { status: 1 };
    
            await this.getLimitedDynamicTableForWhatsappQuickMessages(filters);
            await this.setState({ filtered: false });
            return this.message("success", "Mensagem rápida reativada com sucesso!");
        }
        else
        {
            return this.message("error", "Houve algum erro ao atualizar a mensagem. Se o erro persistir, contacte o TI!");
        }
    }

    render ()
    {
        return (
            <Fragment>
                {
                    this.state.showModalCreateWhatsAppQuickMessages &&
                    <MessageContent
                        message_title={"Criar mensagem rápida"}
                        onClose={() => { this.setState({showModalCreateWhatsAppQuickMessages: false}); }}
                        icon="fa fa-plus"
                        show={this.state.showModalCreateWhatsAppQuickMessages}
                        message_type={"success"}
                        classaditional="boxModalMessageContentWhatsAppQuickMessages"
                    >
                        <div className="boxCreateWhatsAppQuickMessages">
                            <div className="row">
                                <InputGeneral 
                                    label={"Titulo"}
                                    mandatory={"true"}
                                    value={this.state.titleQuickMessage}
                                    onChange={(e) => {
                                        this.setState({ titleQuickMessage: e.target.value})
                                    }}
                                />
                            </div>
                            <div className="row">
                                <InputArea
                                    label="Texto"
                                    mandatory={"true"}
                                    rows="8"
                                    cols="75"
                                    value={this.state.textQuickMessage}
                                    onChange={(e) => {
                                        this.setState({ textQuickMessage: e.target.value})
                                    }}
                                />
                            </div>
                            <div className="row">
                                <Select
                                    label="Departamento"
                                    placeholder="Selecione um departamento..."
                                    mandatory={"true"}
                                    options={this.state.optionsDepartaments}
                                    default={this.state.departamentQuickMessage}
                                    onChange={(departamentQuickMessage) => {
                                        this.setState({ departamentQuickMessage, showCheckShareDepartaments: true })
                                    }}
                                    withFieldSearch
                                />
                            </div>
                            <div className="row">
                                {
                                    this.state.showCheckShareDepartaments &&
                                    <Check 
                                        name={`Compartilhar mensagem rápida com departamentos de mesmo tipo?`}
                                        checked={this.state.checkShareDepartaments}
                                        onClick={() => { this.setState({checkShareDepartaments: !this.state.checkShareDepartaments}) }}
                                    />
                                }
                            </div>
                            <span className="mandatoryInformationWhatsAppQuickMessages">(*) campos com preenchimento obrigatório.</span>
                            <div className="boxButtonsOfModalCreateWhatsAppQuickMessages">
                                <Button 
                                    name="cancelar"
                                    classaditional="buttonCancelCreateWhatsAppQuickMessages"
                                    onClick={() => {
                                        this.setState({ showModalCreateWhatsAppQuickMessages: false });
                                    }}
                                />
                                <Button 
                                    name={this.state.disableButtonSaveCreateWhatsAppQuickMessages ? "aguarde..." : "salvar"}
                                    disabled={this.state.disableButtonSaveCreateWhatsAppQuickMessages}
                                    classaditional="buttonSaveCreateWhatsAppQuickMessages"
                                    onClick={async () => {
                                        this.setState({ disableButtonSaveCreateWhatsAppQuickMessages: true });
                                        await this.createWhatsAppQuickMessages();
                                        this.setState({ disableButtonSaveCreateWhatsAppQuickMessages: false });
                                    }}
                                />
                            </div>
                        </div>
                    </MessageContent>
                }
                {
                    this.state.showModalEditWhatsAppQuickMessages &&
                    <MessageContent
                        message_title={"Editar mensagem rápida"}
                        onClose={() => { this.setState({showModalEditWhatsAppQuickMessages: false}); }}
                        show={this.state.showModalEditWhatsAppQuickMessages}
                        icon="fa fa-pencil-square-o"
                        message_type={"information"}
                        classaditional="boxModalMessageContentWhatsAppQuickMessages"
                    >
                        <div className="boxCreateWhatsAppQuickMessages">
                            <div className="row">
                                <InputGeneral 
                                    label={"Titulo"}
                                    mandatory={"true"}
                                    value={this.state.editTitleQuickMessage}
                                    onChange={(e) => { this.setState({ editTitleQuickMessage: e.target.value}); }}
                                />
                            </div>
                            <div className="row">
                                <InputArea
                                    label="Texto"
                                    mandatory={"true"}
                                    rows="8"
                                    cols="75"
                                    value={this.state.editTextQuickMessage}
                                    onChange={(e) => { this.setState({ editTextQuickMessage: e.target.value}); }}
                                />
                            </div>
                            <div className="row">
                                <Select
                                    label="Departamento"
                                    placeholder="Selecione um departamento..."
                                    mandatory={"true"}
                                    options={this.state.optionsDepartaments}
                                    default={this.state.editDepartamentQuickMessage}
                                    onChange={(editDepartamentQuickMessage) => { this.setState({ editDepartamentQuickMessage, showEditCheckShareDepartaments: true }); }}
                                    withFieldSearch
                                />
                            </div>
                            <div className="row">
                                <Check
                                    name={`Compartilhar mensagem rápida com departamentos de mesmo tipo?`}
                                    checked={this.state.editCheckShareDepartaments}
                                    onClick={() => { this.setState({editCheckShareDepartaments: !this.state.editCheckShareDepartaments}); }}
                                />
                            </div>
                            <span className="mandatoryInformationWhatsAppQuickMessages">(*) campos com preenchimento obrigatório.</span>
                            <div className="boxButtonsOfModalCreateWhatsAppQuickMessages">
                                <Button 
                                    name="cancelar"
                                    classaditional="buttonCancelCreateWhatsAppQuickMessages"
                                    onClick={() => {
                                        this.setState({ 
                                            showModalEditWhatsAppQuickMessages: false,
                                            editTitleQuickMessage: "",
                                            editTextQuickMessage: "",
                                            editDepartamentQuickMessage: null,
                                        });
                                    }}
                                />
                                <Button 
                                    name={this.state.disableButtonSaveCreateWhatsAppQuickMessages ? "aguarde..." : "salvar"}
                                    disabled={this.state.disableButtonSaveCreateWhatsAppQuickMessages}
                                    classaditional="buttonSaveCreateWhatsAppQuickMessages"
                                    onClick={async () => {
                                        await this.setState({disableButtonSaveCreateWhatsAppQuickMessages: true});
                                        await this.editWhatsAppQuickMessages();
                                        await this.setState({disableButtonSaveCreateWhatsAppQuickMessages: false});
                                    }}
                                />
                            </div>
                        </div>
                    </MessageContent>
                }
                {
                    this.state.showDropDownMoreActions &&
                    <DropDown
                        style={{
                            top: `${this.state.posY}px`,
                            left: `${this.state.posX}px`,
                            width: `${this.state.widthDropDownMoreActions}px`,
                        }}
                        onMouseLeave={() => this.setState({showDropDownMoreActions: false})}
                        classaditional="dropMoreActionsWhatsappQuickMessages"
                    >
                        {
                            (this.props.permissions.whatsappQuickMessages && this.props.permissions.whatsappQuickMessages.toFile) &&
                            <Button
                                classaditional="buttonMoreActionsWhatsappQuickMessages"
                                icon="fa fa-archive iconEditWhatsAppQuickMessages"
                                name={this.state.showArchives ? "Desarquivar" : "Arquivar"}
                                onClick={() => this.state.showArchives ? this.activeWhatsAppQuickMessages(this.state.selectIdQuickMessage) : this.archiveWhatsAppQuickMessages(this.state.selectIdQuickMessage)}
                            />
                        }
                        {
                            (this.props.permissions.whatsappQuickMessages && this.props.permissions.whatsappQuickMessages.toUpdate) &&
                            <Button
                                classaditional="buttonMoreActionsWhatsappQuickMessages"
                                icon="fa fa-pencil iconEditWhatsAppQuickMessages"
                                name="Editar"
                                onClick={() => this.openModalEditWhatAppQuickMessages(this.state.selectIdQuickMessage)}
                            />
                        }
                    </DropDown>
                }
                <div className="whatsAppQuickMessages">
                    <Header title="Mensagens rápidas (whatsapp)" classaditional="headerNavigationServiceQueue"/>
                    <div className="containerBodyWhatsAppQuickMessages">
                        <div className="col-12 boxHeaderWhatsAppQuickMessages">
                            <Box>
                                <h4>Mensagens rápidas (whatsapp)</h4>
                            </Box>
                        </div>
                        <div className="col-12 boxActionsWhatAppQuickMessages">
                            <ButtonIcon
                                icon="far fa-bars"
                                classaditional={`buttonNavigationWhatAppQuickMessages ${!this.state.filtered ? "active" : ""}`}
                                onClick={async () => {
                                    this.setState({filtered: false, showArchives: false});
                                    let filters = { status: 1 };
                                    await this.getLimitedDynamicTableForWhatsappQuickMessages(filters);
                                }}
                            />
                            {
                                (this.props.permissions.whatsappQuickMessages && this.props.permissions.whatsappQuickMessages.toFile) &&
                                <ButtonIcon
                                    icon="fas fa-archive"
                                    classaditional={`buttonNavigationWhatAppQuickMessages ${this.state.filtered ? "active" : ""}`}
                                    onClick={async () => {
                                        await this.setState({filtered: true, showArchives: true});
                                        let filters = { status: 2 };
                                        await this.getLimitedDynamicTableForWhatsappQuickMessages(filters);
                                    }}
                                />
                            }
                            <div className="filterBodyWhatAppQuickMessages d-none d-md-flex">
                                <i className="fas fa-building iconfilterBodyWhatAppQuickMessages"></i>
                                <Select
                                    classaditional="selectFilterBodyWhatAppQuickMessages"
                                    default={this.state.choosenDepartament}
                                    options={this.state.optionsDepartamentsFromFilters} 
                                    onChange={async (choosenDepartament) => {
                                        await this.setState({ choosenDepartament })
                                        let filters = {
                                            departament: choosenDepartament.value,
                                            status: this.state.filtered ? 2 : 1
                                        };
                                        await this.getLimitedDynamicTableForWhatsappQuickMessages(filters);
                                    }}
                                    withFieldSearch
                                />
                            </div>
                            {
                                (this.props.permissions.whatsappQuickMessages && this.props.permissions.whatsappQuickMessages.toInsert) &&
                                <div>
                                    <Button
                                        classaditional="buttonCreateWhatAppQuickMessages"
                                        name="nova"
                                        icon="fas fa-bolt mr-2"
                                        onClick={() => { this.openModalCreateWhatAppQuickMessages(); }}
                                    />
                                </div>
                            }
                        </div>
                        <div className="row no-gutters lineBodyWhatsAppQuickMessages">
                            <div className="col-12 columnBodyWhatsAppQuickMessages pl-md-2 pr-md-2">
                                <Box classaditional="boxWhatsAppQuickMessages">
                                    <div className="boxScroolManager">
                                        <div className="boxManagerWhatsAppQuickMessages">
                                            <div className="boxScroolTeam">
                                                <div>
                                                    {this.state.table}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Box>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

function mapStateToProps (state)
{
    const {user} = state.auth;
    const permissions = state.permissions;
    const {hasPermissionsLoaded} = permissions;

    return {
        user,
        permissions,
        hasPermissionsLoaded,
    }
}

function mapDispatchToProps (dispatch)
{
    return {
        setModalMessage (data)
        {
            //action creator -> action
            const action = setModalMessage(data);
            dispatch(action);
        },
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WhatsAppQuickMessages));